export default {
    ASC:'ASC', //Ascending
    DSC: 'DSC', //Descending
}